/**
 * ขนาดมอน (เล็ก/กลาง/ใหญ่) × ชนิดอาวุธ — ตัวคูณดาเมจกายภาพ (ผู้ใช้อนุมัติ 9 ต.ค. 2026)
 *
 * ตารางอยู่ใน `data/balance.json` (`sizeMul`) ที่เดียว ปรับได้โดยไม่แตะโค้ด
 * server คูณใน `playerAttacksMonster` จุดเดียว · เวทไม่สนขนาด · ชนิดที่ไม่อยู่ในตาราง = 1
 */
import balanceJson from "./data/balance.json" with { type: "json" };
export const MONSTER_SIZES = ["small", "medium", "large"];
export const SIZE_NAMES = Object.freeze({
    small: "เล็ก",
    medium: "กลาง",
    large: "ใหญ่",
});
const TABLE = balanceJson.sizeMul;
const CUT = balanceJson.size;
/** ขนาดของมอน: ค่าในข้อมูลก่อน ไม่มี = เดาจากขนาดตัว (`look.size`) · บอสใหญ่เสมอ */
export function sizeOf(mon) {
    if (mon.size)
        return mon.size;
    if (mon.boss)
        return "large";
    const s = mon.look?.size ?? 1;
    return s <= CUT.small ? "small" : s >= CUT.large ? "large" : "medium";
}
/** ตัวคูณดาเมจกายภาพของอาวุธชนิดนี้ใส่มอนขนาดนี้ (เวท/ไม่รู้ชนิด = 1) */
export function sizeMul(weapon, size, magic = false) {
    if (magic || !weapon)
        return 1;
    const row = TABLE[weapon];
    return row ? row[MONSTER_SIZES.indexOf(size)] ?? 1 : 1;
}
//# sourceMappingURL=sizes.js.map